module.exports = __webpack_public_path__ + "static/22_tat9-a3f94a711f84d1a6e47d62af57826c69.jpg";